// src/components/SmoothScroll.js
import React, { useEffect, useRef } from 'react'
import Lenis from 'lenis'

const SmoothScroll = ({ children }) => {
    const wrapperRef = useRef(null)
    const contentRef = useRef(null)

    useEffect(() => {
        const lenis = new Lenis({
            // point Lenis at your div instead of window
            wrapper: wrapperRef.current,
            content: contentRef.current,
            duration: 1.2,
            easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: true
        })

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }
        requestAnimationFrame(raf)

        return () => lenis.destroy()
    }, [])

    return (
        <div
            ref={wrapperRef}
            style={{
                height: '100vh',       // full‐screen container
                overflow: 'hidden'      // let Lenis handle the moving
            }}
        >
            <div ref={contentRef}>
                {children}
            </div>
        </div>
    )
}

export default SmoothScroll
